import type {SelectNetPriceProps} from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import type {RootState} from "~/redux/store";
import type {PriceData} from "~/models/PriceData";
import {selectProperAmountInCart} from "~/AddToCart/redux/cartAmounts/cartAmountSelectors";
import {selectPriceScalingElement} from "~/utils/pricePicker";
import type {SalesData} from "~/SalesCampaign/utils";

export const selectSalesPrice =
  ({ salesData, ...props }: SelectNetPriceProps & { salesData: SalesData | undefined }) =>
  (state: RootState): PriceData | undefined => {
    if (salesData?.price) {
      const cartQty = selectProperAmountInCart(props)(state);
      const totalQuantity = cartQty + (props.extraQuantity ?? 0);
      return selectPriceScalingElement(totalQuantity, salesData.price).price;
    }
  };
